import React, { useEffect, useState } from "react"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { ToastContainer, toast } from "react-toastify"
import ReactPaginate from "react-paginate"
import { URLS } from "../../Url"
import axios from "axios"
import {
  Row,
  Col,
  Card,
  CardBody,
  Input,
  Button,
  Table,
  Label,
  Form,
  FormGroup,
} from "reactstrap"

const Addresses = () => {
  const GetAuth = localStorage.getItem("authUser")
  const TokenJson = JSON.parse(GetAuth)
  const TokenData = TokenJson.token

  const token = JSON.parse(localStorage.getItem("authUser"))?.token

  const [form, setForm] = useState({
    countryId: "",
    stateId: "",
    cityId: "",
    address: "",
    address2: "",
    pincode: "",
    type: "",
    defaultAddress: false,
    otherAddress: "",
  })

  const [editForm, setEditForm] = useState({
    _id: "",
    countryId: "",
    stateId: "",
    cityId: "",
    address: "",
    address2: "",
    pincode: "",
    type: "",
    defaultAddress: false,
    otherAddress: "",
  })

  const [showAddForm, setShowAddForm] = useState(false)
  const [showEditForm, setShowEditForm] = useState(false)

  const [data, setData] = useState([])
  const [countries, setCountries] = useState([])
  const [states, setStates] = useState([])
  const [cities, setCities] = useState([])

  const [editStates, setEditStates] = useState([])
  const [editCities, setEditCities] = useState([])

  const [listPerPage] = useState(10)
  const [pageNumber, setPageNumber] = useState(0)

  useEffect(() => {
    fetchAddresses()
    fetchCountries()
  }, [])

  const fetchAddresses = () => {
    axios
      .post(
        URLS.GetAddress,
        {},
        {
          headers: { Authorization: `Bearer ${TokenData}` },
        }
      )
      .then(res => {
        setData(res.data.userAddress)
      })
      .catch(error => {
        toast.error("Failed to fetch addresses")
      })
  }

  const fetchCountries = async () => {
    try {
      const response = await axios.post(
        URLS.GetCountry,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      )
      setCountries(response.data.countrys)
    } catch (error) {
      toast.error("Failed to fetch countries")
    }
  }

  const handleCountryChange = async e => {
    const { name, value } = e.target
    setForm(prev => ({ ...prev, [name]: value, stateId: "", cityId: "" }))

    if (value) {
      try {
        const response = await axios.post(
          URLS.GetCountrybyStateId,
          { country_id: value },
          { headers: { Authorization: `Bearer ${token}` } }
        )
        setStates(response.data.states)
        setCities([])
      } catch (error) {
        toast.error("Failed to fetch states")
      }
    } else {
      setStates([])
      setCities([])
    }
  }

  const handleStateChange = async e => {
    const { name, value } = e.target
    setForm(prev => ({ ...prev, [name]: value, cityId: "" }))

    if (value) {
      try {
        const response = await axios.post(
          URLS.GetStatebyCityId,
          { state_id: value },
          { headers: { Authorization: `Bearer ${token}` } }
        )
        setCities(response.data.cities)
      } catch (error) {
        toast.error("Failed to fetch cities")
      }
    } else {
      setCities([])
    }
  }

  const handleEditCountryChange = async e => {
    const { name, value } = e.target
    setEditForm(prev => ({ ...prev, [name]: value, stateId: "", cityId: "" }))

    if (value) {
      try {
        const response = await axios.post(
          URLS.GetCountrybyStateId,
          { country_id: value },
          { headers: { Authorization: `Bearer ${token}` } }
        )
        setEditStates(response.data.states)
        setEditCities([])
      } catch (error) {
        toast.error("Failed to fetch states")
      }
    } else {
      setEditStates([])
      setEditCities([])
    }
  }

  const handleEditStateChange = async e => {
    const { name, value } = e.target
    setEditForm(prev => ({ ...prev, [name]: value, cityId: "" }))

    if (value) {
      try {
        const response = await axios.post(
          URLS.GetStatebyCityId,
          { state_id: value },
          { headers: { Authorization: `Bearer ${token}` } }
        )
        setEditCities(response.data.cities)
      } catch (error) {
        toast.error("Failed to fetch cities")
      }
    } else {
      setEditCities([])
    }
  }

  const handleInputChange = e => {
    const { name, value } = e.target
    setForm(prev => ({ ...prev, [name]: value }))
  }

  const handleEditInputChange = e => {
    const { name, value } = e.target
    setEditForm(prev => ({ ...prev, [name]: value }))
  }

  const handleCheckboxChange = e => {
    const { name, checked } = e.target
    setForm(prev => ({ ...prev, [name]: checked }))
  }

  const handleEditCheckboxChange = e => {
    const { name, checked } = e.target
    setEditForm(prev => ({ ...prev, [name]: checked }))
  }

  const handleAddSubmit = e => {
    e.preventDefault()
    addAddress()
  }

  const addAddress = () => {
    axios
      .post(URLS.AddAddress, form, {
        headers: { Authorization: `Bearer ${TokenData}` },
      })
      .then(res => {
        if (res.status === 200) {
          toast.success(res.data.message)
          setShowAddForm(false)
          setForm({
            countryId: "",
            stateId: "",
            cityId: "",
            address: "",
            address2: "",
            pincode: "",
            type: "",
            defaultAddress: false,
            otherAddress: "",
          })
          fetchAddresses()
        }
      })
      .catch(error => {
        if (error.response && error.response.status === 400) {
          toast.error(error.response.data.message)
        }
      })
  }

  const handleEditSubmit = e => {
    e.preventDefault()
    updateAddress()
  }

  const updateAddress = () => {
    axios
      .put(URLS.EditAddress + editForm._id, editForm, {
        headers: { Authorization: `Bearer ${TokenData}` },
      })
      .then(res => {
        if (res.status === 200) {
          toast.success(res.data.message)
          setShowEditForm(false)
          fetchAddresses()
        }
      })
      .catch(error => {
        if (error.response && error.response.status === 400) {
          toast.error(error.response.data.message)
        }
      })
  }

  const deleteAddress = address => {
    const confirmBox = window.confirm(
      "Do you really want to delete this address?"
    )
    if (confirmBox === true) {
      axios
        .delete(URLS.DeleteAddress + address._id, {
          headers: { Authorization: `Bearer ${TokenData}` },
        })
        .then(res => {
          if (res.status === 200) {
            toast.success(res.data.message)
            fetchAddresses()
          }
        })
        .catch(error => {
          if (error.response && error.response.status === 400) {
            toast.error(error.response.data.message)
          }
        })
    }
  }

  const openEditForm = address => {
    setEditForm({
      _id: address._id,
      countryId: address.countryId,
      stateId: address.stateId,
      cityId: address.cityId,
      address: address.address,
      address2: address.address2,
      pincode: address.pincode,
      type: address.type,
      defaultAddress: address.defaultAddress,
      otherAddress: address.otherAddress,
    })

    // Fetch states for the country of the address being edited
    if (address.countryId) {
      axios
        .post(
          URLS.GetCountrybyStateId,
          { country_id: address.countryId },
          { headers: { Authorization: `Bearer ${token}` } }
        )
        .then(response => {
          setEditStates(response.data.states)

          // Fetch cities for the state of the address being edited
          if (address.stateId) {
            axios
              .post(
                URLS.GetStatebyCityId,
                { state_id: address.stateId },
                { headers: { Authorization: `Bearer ${token}` } }
              )
              .then(response => {
                setEditCities(response.data.cities)
              })
              .catch(error => {
                toast.error("Failed to fetch cities")
              })
          }
        })
        .catch(error => {
          toast.error("Failed to fetch states")
        })
    }

    setShowEditForm(true)
    setShowAddForm(false)
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    })
  }

  const pagesVisited = pageNumber * listPerPage
  const displayedAddresses = data.slice(
    pagesVisited,
    pagesVisited + listPerPage
  )
  const pageCount = Math.ceil(data.length / listPerPage)

  const changePage = ({ selected }) => {
    setPageNumber(selected)
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Bizzmate Supplier" breadcrumbItem="Address" />

          {/* Add Address Form */}
          <Row>
            <Col md={12}>
              {showAddForm && (
                <Card>
                  <CardBody>
                    <Form onSubmit={handleAddSubmit}>
                      <Row>
                        <Col md="6">
                          <FormGroup className="mb-3">
                            <Label>
                              Country <span className="text-danger">*</span>
                            </Label>
                            <select
                              name="countryId"
                              className="form-control"
                              value={form.countryId}
                              onChange={handleCountryChange}
                              required
                            >
                              <option value="">Select Country</option>
                              {countries.map(country => (
                                <option key={country.id} value={country.id}>
                                  {country.name}
                                </option>
                              ))}
                            </select>
                          </FormGroup>
                        </Col>
                        <Col md="6">
                          <FormGroup className="mb-3">
                            <Label>
                              State <span className="text-danger">*</span>
                            </Label>
                            <select
                              name="stateId"
                              value={form.stateId}
                              className="form-control"
                              onChange={handleStateChange}
                              disabled={!form.countryId}
                              required
                            >
                              <option value="">Select State</option>
                              {states.map(state => (
                                <option key={state.id} value={state.id}>
                                  {state.name}
                                </option>
                              ))}
                            </select>
                          </FormGroup>
                        </Col>
                        <Col md="6">
                          <FormGroup className="mb-3">
                            <Label>
                              City <span className="text-danger">*</span>
                            </Label>
                            <select
                              name="cityId"
                              value={form.cityId}
                              onChange={handleInputChange}
                              className="form-control"
                              disabled={!form.stateId}
                              required
                            >
                              <option value="">Select City</option>
                              {cities.map(city => (
                                <option key={city.id} value={city.id}>
                                  {city.name}
                                </option>
                              ))}
                            </select>
                          </FormGroup>
                        </Col>
                        <Col md="6">
                          <FormGroup className="mb-3">
                            <Label>
                              Pincode <span className="text-danger">*</span>
                            </Label>
                            <Input
                              type="text"
                              placeholder="Enter Pincode"
                              name="pincode"
                              value={form.pincode}
                              onChange={handleInputChange}
                              required
                              onKeyPress={e => {
                                const charCode = e.which ? e.which : e.keyCode
                                if (charCode < 48 || charCode > 57) {
                                  e.preventDefault()
                                }
                              }}
                              maxLength="6"
                              minLength="6"
                              pattern="[0-9]{6}"
                            />
                          </FormGroup>
                        </Col>
                        <Col md="6">
                          <FormGroup className="mb-3">
                            <Label>
                              Address 1<span className="text-danger">*</span>
                            </Label>
                            <Input
                              type="textarea"
                              placeholder="Enter Address 1"
                              rows={1}
                              name="address"
                              value={form.address}
                              onChange={handleInputChange}
                              required
                            />
                          </FormGroup>
                        </Col>
                        <Col md="6">
                          <FormGroup className="mb-3">
                            <Label>Address 2</Label>
                            <Input
                              type="textarea"
                              placeholder="Enter Address 2"
                              rows={1}
                              name="address2"
                              value={form.address2}
                              onChange={handleInputChange}
                            />
                          </FormGroup>
                        </Col>
                        <Col md="6">
                          <FormGroup className="mb-3">
                            <Label>
                              Type <span className="text-danger">*</span>
                            </Label>
                            <select
                              name="type"
                              value={form.type}
                              onChange={handleInputChange}
                              className="form-control"
                              required
                            >
                              <option value="">Select Type</option>
                              <option value="Home">Home</option>
                              <option value="Office">Office</option>
                              <option value="Other">Other</option>
                            </select>
                          </FormGroup>
                        </Col>
                        {form.type == "Other" ? (
                          <>
                            <Col md="6">
                              <FormGroup className="mb-3">
                                <Label>Other Address Type</Label>
                                <Input
                                  type="textarea"
                                  placeholder="Enter Other Address Type"
                                  rows={1}
                                  required
                                  name="otherAddress"
                                  value={form.otherAddress}
                                  onChange={handleInputChange}
                                />
                              </FormGroup>
                            </Col>
                          </>
                        ) : (
                          ""
                        )}
                        <Col md={6}>
                          <FormGroup
                            check
                            className="mt-4 d-flex justify-content-center"
                          >
                            <Label check>
                              <Input
                                type="checkbox"
                                name="defaultAddress"
                                defaultChecked={form.defaultAddress}
                                value={form.defaultAddress}
                                onChange={handleCheckboxChange}
                                style={{ fontSize: "20px" }}
                              />
                              Default Address
                            </Label>
                          </FormGroup>
                        </Col>
                        <Col md={12}>
                          <div className="text-end mt-4">
                            <Button
                              type="button"
                              onClick={() => setShowAddForm(false)}
                              color="danger m-1"
                              size="sm"
                            >
                              Cancel <i className="bx bx-x-circle"></i>
                            </Button>
                            <Button type="submit" color="primary m-1" size="sm">
                              Submit <i className="bx bx-check-circle"></i>
                            </Button>
                          </div>
                        </Col>
                      </Row>
                    </Form>
                  </CardBody>
                </Card>
              )}
            </Col>
          </Row>

          <Row>
            <Col md={12}>
              {showEditForm && (
                <Card>
                  <CardBody>
                    <Form onSubmit={handleEditSubmit}>
                      <Row>
                        <h5 className="mb-3">Edit Address</h5>
                        <Col md="6">
                          <FormGroup className="mb-3">
                            <Label>
                              Country <span className="text-danger">*</span>
                            </Label>
                            <select
                              name="countryId"
                              className="form-control"
                              value={editForm.countryId}
                              onChange={handleEditCountryChange}
                              required
                            >
                              <option value="">Select Country</option>
                              {countries.map(country => (
                                <option key={country.id} value={country.id}>
                                  {country.name}
                                </option>
                              ))}
                            </select>
                          </FormGroup>
                        </Col>
                        <Col md="6">
                          <FormGroup className="mb-3">
                            <Label>
                              State <span className="text-danger">*</span>
                            </Label>
                            <select
                              name="stateId"
                              value={editForm.stateId}
                              className="form-control"
                              onChange={handleEditStateChange}
                              disabled={!editForm.countryId}
                              required
                            >
                              <option value="">Select State</option>
                              {editStates.map(state => (
                                <option key={state.id} value={state.id}>
                                  {state.name}
                                </option>
                              ))}
                            </select>
                          </FormGroup>
                        </Col>
                        <Col md="6">
                          <FormGroup className="mb-3">
                            <Label>
                              City <span className="text-danger">*</span>
                            </Label>
                            <select
                              name="cityId"
                              value={editForm.cityId}
                              onChange={handleEditInputChange}
                              className="form-control"
                              disabled={!editForm.stateId}
                              required
                            >
                              <option value="">Select City</option>
                              {editCities.map(city => (
                                <option key={city.id} value={city.id}>
                                  {city.name}
                                </option>
                              ))}
                            </select>
                          </FormGroup>
                        </Col>
                        <Col md="6">
                          <FormGroup className="mb-3">
                            <Label>
                              Pincode <span className="text-danger">*</span>
                            </Label>
                            <Input
                              type="text"
                              placeholder="Enter Pincode"
                              name="pincode"
                              value={editForm.pincode}
                              onChange={handleEditInputChange}
                              required
                              onKeyPress={e => {
                                const charCode = e.which ? e.which : e.keyCode
                                if (charCode < 48 || charCode > 57) {
                                  e.preventDefault()
                                }
                              }}
                              maxLength="6"
                              minLength="6"
                              pattern="[0-9]{6}"
                            />
                          </FormGroup>
                        </Col>
                        <Col md="6">
                          <FormGroup className="mb-3">
                            <Label>
                              Address 1<span className="text-danger">*</span>
                            </Label>
                            <Input
                              type="textarea"
                              placeholder="Enter Address 1"
                              rows={1}
                              name="address"
                              value={editForm.address}
                              onChange={handleEditInputChange}
                              required
                            />
                          </FormGroup>
                        </Col>
                        <Col md="6">
                          <FormGroup className="mb-3">
                            <Label>Address 2</Label>
                            <Input
                              type="textarea"
                              placeholder="Enter Address 2"
                              rows={1}
                              name="address2"
                              value={editForm.address2}
                              onChange={handleEditInputChange}
                            />
                          </FormGroup>
                        </Col>
                        <Col md="6">
                          <FormGroup className="mb-3">
                            <Label>
                              Type <span className="text-danger">*</span>
                            </Label>
                            <select
                              name="type"
                              value={editForm.type}
                              onChange={handleEditInputChange}
                              className="form-control"
                              required
                            >
                              <option value="">Select Type</option>
                              <option value="Home">Home</option>
                              <option value="Office">Office</option>
                              <option value="Other">Other</option>
                            </select>
                          </FormGroup>
                        </Col>
                        {editForm.type == "Other" ? (
                          <>
                            <Col md="6">
                              <FormGroup className="mb-3">
                                <Label>Other Address Type</Label>
                                <Input
                                  type="textarea"
                                  placeholder="Enter Other Address Type"
                                  rows={1}
                                  required
                                  name="otherAddress"
                                  value={editForm.otherAddress}
                                  onChange={handleEditInputChange}
                                />
                              </FormGroup>
                            </Col>
                          </>
                        ) : (
                          ""
                        )}
                        <Col md={6}>
                          <FormGroup
                            check
                            className="mt-4 d-flex justify-content-center"
                          >
                            <Label check>
                              <Input
                                type="checkbox"
                                name="defaultAddress"
                                defaultChecked={editForm.defaultAddress}
                                value={editForm.defaultAddress}
                                onChange={handleEditCheckboxChange}
                                style={{ fontSize: "20px" }}
                              />
                              Default Address
                            </Label>
                          </FormGroup>
                        </Col>
                        <Col md={12}>
                          <div className="text-end mt-4">
                            <Button
                              type="button"
                              onClick={() => setShowEditForm(false)}
                              color="danger m-1"
                              size="sm"
                            >
                              Cancel <i className="bx bx-x-circle"></i>
                            </Button>
                            <Button
                              type="submit"
                              size="sm"
                              color="primary text-white m-1"
                            >
                              Update <i className="bx bx-check-circle"></i>
                            </Button>
                          </div>
                        </Col>
                      </Row>
                    </Form>
                  </CardBody>
                </Card>
              )}
            </Col>
          </Row>

          <Row>
            <Col md={12}>
              <Card>
                <CardBody>
                  <Row>
                    <Col>
                      <Button
                        color="primary"
                        onClick={() => {
                          setShowAddForm(true)
                          setShowEditForm(false)
                        }}
                        size="sm"
                      >
                        Create Address <i className="bx bx-plus-circle"></i>
                      </Button>
                    </Col>
                  </Row>
                  <div className="table-rep-plugin mt-4 table-responsive">
                    <Table hover bordered responsive>
                      <thead>
                        <tr className="text-center">
                          <th>Sl.No</th>
                          <th>Country</th>
                          <th>State</th>
                          <th>City</th>
                          <th>Address</th>
                          <th>Address 2</th>
                          <th>Other Address Type</th>
                          <th>Pincode</th>
                          <th>Type</th>
                          <th>Default</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {displayedAddresses.length > 0 ? (
                          displayedAddresses.map((address, index) => (
                            <tr key={address._id} className="text-center">
                              <td>{pagesVisited + index + 1}</td>
                              <td>{address.countryName}</td>
                              <td>{address.stateName}</td>
                              <td>{address.cityName}</td>
                              <td>{address.address}</td>
                              <td>{address.address2 || "-"}</td>
                              <td>{address.otherAddress || "-"}</td>
                              <td>{address.pincode}</td>
                              <td>{address.type}</td>
                              <td>
                                {address.defaultAddress ? (
                                  <b className="text-success">Yes</b>
                                ) : (
                                  <b className="text-danger"> No</b>
                                )}
                              </td>
                              <td>
                                {/* <Button
                                onClick={() => openEditForm(address)}
                                  size="sm"
                                  className="m-1"
                                  outline
                                  color="primary"
                                > */}
                                <i
                                  className="bx bx-edit me-2 text-primary"
                                  onClick={() => openEditForm(address)}
                                  style={{
                                    fontSize: "22px",
                                    cursor: "pointer",
                                  }}
                                ></i>
                                {/* </Button> */}
                                {/* <Button
                                  size="sm"
                                  outline
                                  className="m-1"
                                  color="primary"
                                  onClick={() => deleteAddress(address)}
                                > */}
                                <i
                                  className="bx bx-trash  text-primary"
                                  onClick={() => deleteAddress(address)}
                                  style={{
                                    fontSize: "22px",
                                    cursor: "pointer",
                                  }}
                                ></i>
                                {/* </Button> */}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="10" className="text-center">
                              No addresses found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                    {pageCount > 1 && (
                      <Col sm="12">
                        <div
                          className="d-flex mt-3 mb-1 "
                          style={{ float: "right" }}
                        >
                          <ReactPaginate
                            previousLabel={"Previous"}
                            nextLabel={"Next"}
                            pageCount={pageCount}
                            onPageChange={changePage}
                            containerClassName={"pagination"}
                            previousLinkClassName={"page-link"}
                            nextLinkClassName={"page-link"}
                            disabledClassName={"disabled"}
                            activeClassName={"active"}
                            pageClassName={"page-item"}
                            pageLinkClassName={"page-link"}
                          />
                        </div>
                      </Col>
                    )}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
        <ToastContainer />
      </div>
    </React.Fragment>
  )
}

export default Addresses
